import moment from 'moment-timezone'
import { defaultTimeZoneId } from '@/config/flavor'

/** 常用 IANA 时区（置顶展示） */
export const COMMON_TIME_ZONE_IDS = [
  'UTC',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Taipei',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Asia/Singapore',
  'Asia/Bangkok',
  'Asia/Kolkata',
  'Asia/Dubai',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Moscow',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Sao_Paulo',
  'Australia/Sydney',
  'Pacific/Auckland',
]

const LEGACY_OFFSET_TO_IANA = {
  8: 'Asia/Shanghai',
  0: 'UTC',
  9: 'Asia/Tokyo',
  1: 'Europe/Paris',
  5: 'Asia/Kolkata',
  '-5': 'America/New_York',
  '-8': 'America/Los_Angeles',
}

export function isValidTimeZoneId (value) {
  if (value == null || value === '') {
    return false
  }
  return moment.tz.zone(String(value).trim()) != null
}

/**
 * 规范化账号 IANA 时区。
 * 仅对空值 / 遗留整型偏移回退默认；非法 IANA 字符串回退默认并打 warn。
 */
export function normalizeTimeZoneId (value) {
  if (value == null || value === '') {
    return defaultTimeZoneId
  }
  if (typeof value === 'number' || (typeof value === 'string' && /^-?\d+$/.test(value.trim()))) {
    const key = String(Number(value))
    return LEGACY_OFFSET_TO_IANA[key] || defaultTimeZoneId
  }
  const trimmed = String(value).trim()
  if (isValidTimeZoneId(trimmed)) {
    return trimmed
  }
  if (typeof console !== 'undefined' && console.warn) {
    console.warn('[timezone] unknown IANA id, using default', defaultTimeZoneId + ':', trimmed)
  }
  return defaultTimeZoneId
}

export function formatTimeZoneLabel (timeZoneId) {
  const id = isValidTimeZoneId(timeZoneId) ? String(timeZoneId).trim() : normalizeTimeZoneId(timeZoneId)
  const offset = moment.tz(id).format('Z')
  return `(UTC${offset}) ${id}`
}

export function buildTimeZoneOptions (ids) {
  return ids.map((id) => ({
    id,
    label: formatTimeZoneLabel(id),
  }))
}

/** 全量 IANA 列表：常用置顶 + 其余字母序 */
export function buildAllTimeZoneOptions () {
  const allNames = moment.tz.names()
  const common = COMMON_TIME_ZONE_IDS.filter((id) => moment.tz.zone(id))
  const commonSet = new Set(common)
  const rest = allNames.filter((id) => !commonSet.has(id)).sort()
  return buildTimeZoneOptions([...common, ...rest])
}

export const TIME_ZONE_OPTIONS = buildAllTimeZoneOptions()

export function findTimeZoneLabel (timeZoneId) {
  return formatTimeZoneLabel(timeZoneId)
}

/** 确保 value 出现在 options 中（迁移产生的 Etc/GMT 等） */
export function ensureTimeZoneOption (options, timeZoneId) {
  if (!timeZoneId || !isValidTimeZoneId(timeZoneId)) {
    return options
  }
  const id = String(timeZoneId).trim()
  if (options.some((item) => item.id === id)) {
    return options
  }
  return [{ id, label: formatTimeZoneLabel(id) }, ...options]
}
